﻿import { ref, readonly } from 'vue';
import type { User } from '@/types';
import { openModal } from './useModal';

const currentUser = ref<User | null>(null);

if (window.VueBridge) {
    window.VueBridge.on('userUpdated', (user) => {
        currentUser.value = JSON.parse(JSON.stringify(user))
    })
    window.openVueModal = openModal;
}

export const useAngularState = () => {
    return { currentUser: readonly(currentUser) };
}
